import declare from "dojo/_base/declare";
import { Context } from "csi/def/Context";
import Path from "./Path";
import Spec from "csi/core/Spec";

/**
 * This matrix allows you to store data in maps belonging to each row node. The key to the map is taken
 * from an attribute on each column node that stores a unique value.
 * 
 * Reference: https://centric8.atlassian.net/wiki/spaces/AAT/pages/1298825877/Table+Matrix+Configuration#ColumnMap
 */

const ColumnMap = declare(Path, {
	/** @property {string} mapKeyColumnId - attribute id of column class that holds unique id for column */
	mapKeyColumnId: "SysID",

	/**
	 * @override
	 * Set index for column to unique value from configured attribute if this is not a matrix group (no sub-specs)
	 */
	onPathSpecParams(ctx: Context, params: Partial<Spec>, columnIndex: number): void {
		if (!params.subs) {
			this.onPathSubSpecParams(ctx, params, columnIndex);
		}
	},

	/** 
	 * @override
	 * Set index for column to unique value from configured attribute 
	 */
	onPathSubSpecParams(ctx: Context, params: any, columnIndex: number): void {
		params.index = ctx.getNodeAttributeValue(this.mapKeyColumnId, false);
	},
});

export = ColumnMap;